'use strict';

/**
 * User Service
 */
module.service('analysisService', [ 'Restangular', '$q', analysisServiceFn]);
function analysisServiceFn(Restangular, $q) {

	/*
	 * ------------------------------------------------------------------------------
	 * SERVICE FUNCTIONS
	 * -------------------------------------------------------------------------------
	 */
	var analysisResource = Restangular.all('analysis');
	var rs = {};

	rs.searchRegulations = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();

		analysisResource.customGET('list', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	rs.createAnalysis = function(createModel) {
		var deferred = $q.defer();
		var answer = new restResponse();

		analysisResource.customPOST(createModel, 'create').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}
	rs.removeAnalysis = function(idAnalysis) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('analysis',idAnalysis).one('delete').remove().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}
	rs.enableAnalysis = function(idAnalysis) {
		var deferred = $q.defer();
		var answer = new restResponse();
		analysisResource.customPUT(null,  idAnalysis + '/enable').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.disableAnalysis = function(idAnalysis) {
		var deferred = $q.defer();
		var answer = new restResponse();
		analysisResource.customPUT(null, idAnalysis + '/disable').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	rs.searchTechniques = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();

		analysisResource.customGET('listTechnique', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	rs.createTechnique = function(createModel) {
		var deferred = $q.defer();
		var answer = new restResponse();

		analysisResource.customPOST(createModel, 'techniqueCreate').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	},
	
	rs.updateTechnique = function(idTechnique, updateModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		
		Restangular.one('analysis').one('techniqueUpdate', idTechnique).customPUT(updateModel).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	rs.getTechnique = function(idTechnique) {
		var deferred = $q.defer();
		var answer = new restResponse();
		analysisResource.customGET('technique/' + idTechnique, null).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	rs.addTechniqueSamplingMethod = function(idTechnique, samplingMethod) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('analysis').one('technique', idTechnique).customPOST(samplingMethod, 'samplingmethod')
				.then(function(response) {
					answer.handleSuccessfullResponse(response, response.data);
					deferred.resolve(answer);
				}, function(response) {
					answer.handleErrorResponse(response, response.data);
					deferred.reject(answer);
				});

		return deferred.promise;
	}

	rs.updateTechniqueSamplingMethod = function(idTechnique, idSamplingMethod, samplingMethod) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('analysis').one('technique', idTechnique).one('samplingmethod', idSamplingMethod).customPUT(samplingMethod).then(function(response) {
					answer.handleSuccessfullResponse(response, response.data);
					deferred.resolve(answer);
				}, function(response) {
					answer.handleErrorResponse(response, response.data);
					deferred.reject(answer);
				});

		return deferred.promise;
	}
	
	rs.removeTechniqueSamplingMethod = function(idTechnique, idSamplingMethod) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('analysis').one('technique', idTechnique).one('samplingmethod', idSamplingMethod).remove()
				.then(function(response) {
					answer.handleSuccessfullResponse(response, response.data);
					deferred.resolve(answer);
				}, function(response) {
					answer.handleErrorResponse(response, response.data);
					deferred.reject(answer);
				});

		return deferred.promise;
	}
	
	rs.searchMethodInTechnique = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();

		analysisResource.customGET('listMethods', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	rs.searchAnalysisTechnique = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();

		analysisResource.customGET('listAnalysisTechnique', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	rs.removeTechniqueAnalysis = function(idAnalysis,idtechnique,idMethod) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('analysis',idAnalysis).one('technique', idtechnique).one('samplingmethod', idMethod).remove()
				.then(function(response) {
					answer.handleSuccessfullResponse(response, response.data);
					deferred.resolve(answer);
				}, function(response) {
					answer.handleErrorResponse(response, response.data);
					deferred.reject(answer);
				});

		return deferred.promise;
	}
	
	return rs;
}